import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { IconButton, Typography } from 'seagull';
import { ArrowLeft } from 'seagull/icons';
import styles from './MobileVendorHeader.module.scss';
export const MobileVendorHeader = (param)=>{
    let { vendorName, vendorLogoUrl, onBack, testId, backButtonTestId } = param;
    return /*#__PURE__*/ _jsxs("div", {
        "data-testid": testId,
        className: styles.header,
        children: [
            /*#__PURE__*/ _jsx("div", {
                className: styles.backButtonSlot,
                children: onBack != null && /*#__PURE__*/ _jsx(IconButton, {
                    bi: {
                        name: 'ad_hoc_invoice_mobile_back'
                    },
                    testId: backButtonTestId,
                    className: styles.backButton,
                    onClick: onBack,
                    children: /*#__PURE__*/ _jsx(ArrowLeft, {
                        size: 24
                    })
                })
            }),
            /*#__PURE__*/ _jsx("div", {
                className: styles.logoSlot,
                children: vendorLogoUrl != null ? /*#__PURE__*/ _jsx("img", {
                    src: vendorLogoUrl,
                    alt: vendorName,
                    className: styles.vendorLogo
                }) : /*#__PURE__*/ _jsx(Typography, {
                    variant: "paragraph1",
                    weight: "bold",
                    children: vendorName
                })
            }),
            /*#__PURE__*/ _jsx("div", {
                className: styles.spacer
            })
        ]
    });
};
